import type { SomethingWithState, OnAddToBoard } from "../interfaces";
import { PhysicalThing } from "../physicalThing";
import { deserializeXY } from "../serialization";
import type { XY } from "../xy";
import { ZOrder } from "../zOrder";

export enum LavaPoolState {
	TOP = "TOP",
	NORMAL = "NORMAL",
}

export class LavaPool extends PhysicalThing implements SomethingWithState, OnAddToBoard {
	static key = "LavaPool";
	private state: LavaPoolState = LavaPoolState.TOP;
	passable: boolean = false;

	constructor(xy: XY) {
		super(xy, true);
	}

	setPassable(value: boolean): void {
		this.passable = value;
		this.blocksMovement = !value;
	}

	getZOrder(): number {
		return ZOrder.CARPET_LIKE;
	}

	override isGasPermeable(): boolean {
		return true;
	}

	onAddToBoard(): void {
		const northXY = this.xy.add(0, -1);
		if (this.board!.isInBounds(northXY)) {
			const hasLava = this.board!.getThingsAt(northXY).some((t) => t instanceof LavaPool);
			this.state = hasLava ? LavaPoolState.NORMAL : LavaPoolState.TOP;
		} else {
			this.state = LavaPoolState.NORMAL;
		}
	}

	getState(): LavaPoolState {
		return this.state;
	}

	serialize(): Record<string, unknown> {
		return { ...super.serialize(), state: this.state, passable: this.passable };
	}

	static deserialize(data: any): LavaPool {
		const l = new LavaPool(deserializeXY(data.xy));
		l.visualId = data.visualId;
		l.state = data.state ?? LavaPoolState.TOP;
		l.setPassable(data.passable ?? false);
		return l;
	}
}
